import {
  ChevronLeftIcon,
  ChevronRightIcon,
  Typography,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';

import styles from './bannerPagination.module.css';

type BannerPaginationProps = {
  activeIndex: number;
  totalItems: number;
  updateIndex: (index: number) => void;
};

export function BannerPagination({
  activeIndex,
  totalItems,
  updateIndex,
}: BannerPaginationProps) {
  const nextIndex = (activeIndex + 1) % totalItems;
  const prevIndex = (activeIndex + totalItems - 1) % totalItems;

  return (
    <div className={styles['imagePagination']}>
      <button
        type="button"
        className={clsx(styles['buttonWrapper'], styles['rightButtonWrapper'])}
        onClick={() => updateIndex(prevIndex)}
        aria-label="View previous item"
      >
        <ChevronLeftIcon color="grays-white" />
      </button>

      <button
        type="button"
        className={clsx(styles['buttonWrapper'], styles['leftButtonWrapper'])}
        onClick={() => updateIndex(nextIndex)}
        aria-label="View next item"
      >
        <ChevronRightIcon color="grays-white" />
      </button>

      <div
        className={clsx(
          styles['paginationTextWrapper'],
          styles['paginationTextWrapperPosition']
        )}
      >
        <Typography variant="mini" color="grays-white">
          {activeIndex + 1}&#47;{totalItems}
        </Typography>
      </div>
    </div>
  );
}
